/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Track_Hint_LinkInputs */

const en_common_support_track_hint_link = /** @type {(inputs: Common_Support_Track_Hint_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Tickets`)
};

const zh_common_support_track_hint_link = /** @type {(inputs: Common_Support_Track_Hint_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单支持页面查看回复`)
};

/**
* | output |
* | --- |
* | "Support Tickets" |
*
* @param {Common_Support_Track_Hint_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_track_hint_link = /** @type {((inputs?: Common_Support_Track_Hint_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Track_Hint_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_track_hint_link(inputs)
	return zh_common_support_track_hint_link(inputs)
});
export { common_support_track_hint_link as "common.support.track_hint_link" }